import styled from '@emotion/styled';
import { pulse } from '$shared/utils';

type StyledProductListProps = {
    isLoading?: boolean;
};
export const StyledProductList = styled.div<StyledProductListProps>(({ isLoading }) => ({
    ...(isLoading ? { ...pulse } : {}),
}));
